export default __webpack_public_path__ + "static/media/G0006.39f60781.png";